import { render, staticRenderFns } from "./DetailsSalesSignrequestBox.vue?vue&type=template&id=16ce3680"
import script from "./DetailsSalesSignrequestBox.vue?vue&type=script&lang=ts"
export * from "./DetailsSalesSignrequestBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports